<div class="main-content">
    <div class="card">
        <p-toolbar styleClass="p-mb-4">
            <ng-template pTemplate="left"></ng-template>
            <ng-template pTemplate="right">
                <button *ngIf="categoriesListToUpdate.length" pButton pRipple label="{{ 'BUTTONS.SAVE' | translate }}" icon="pi pi-save" class="p-button-success mr-2 njoyButton"
                        (click)="updateListCategories()"></button>
                <button pButton pRipple label="{{ 'CATEGORY.ADD_NEW' | translate }}" icon="pi pi-plus"
                        class="p-button-success mr-2 njoyButton"
                        (click)="addNew()"></button>
            </ng-template>
        </p-toolbar>
        <p-table #dt [value]="categories" [rowHover]="true">
            <ng-template pTemplate="header">
                <tr>
                    <th>{{ 'CATEGORY.LABEL' | translate }}</th>
                    <th>{{ 'CATEGORY.BACKGROUND_IMAGE' | translate }}</th>
                    <th>{{ 'CATEGORY.EMOJI' | translate }}</th>
                    <th>{{ 'CATEGORY.FAMILY' | translate }}</th>
                    <th></th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template let-i="rowIndex" pTemplate="body" let-category>
                <tr (dblclick)="openUpdateModal(category)">
                    <td>{{category?.label}}</td>
                    <td>
                        <div class="logo-container" *ngIf="category.backgroundImagePath">
                            <img [src]="category?.backgroundImagePath" class="small-logo"/>
                            <span class="logo-tooltip">
                                            <img [src]="category?.backgroundImagePath" class="middle-logo"/>
                                        </span>
                        </div>
                        <img src="assets/icons/shared/image-not-found.png" alt="" class="small-logo"
                             *ngIf="!category.backgroundImagePath">
                    </td>
                    <td>
                        <p *ngIf="category.emoji" class="emoji"
                           [innerHTML]="sanitizer.bypassSecurityTrustHtml(category?.emoji)"></p>
                    </td>
                    <td>
                        <i class="pi pi-check" *ngIf="category.family"></i>
                    </td>
                    <td>
                        <i *ngIf="i!= 0" (click)="increasePriority(category);$event.stopPropagation()"
                           class="pi pi-chevron-up"></i>
                        <i *ngIf="i!= categories.length-1" (click)="decreasePriority(category);$event.stopPropagation()"
                           class="pi pi-chevron-down"></i>
                    </td>
                    <td>
                        <button pButton pRipple icon="pi pi-times" class="p-button-rounded njoyButton"
                                (click)="confirmDeleteCategory(category)"></button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
<p-dialog *ngIf="addNewCategoryDialog" [(visible)]="addNewCategoryDialog" [style]="{width: '600px'}"
          [header]="modalTitle" [modal]="true"
          styleClass="p-fluid">

    <div class="container-fluid">
        <form [formGroup]="categoryForm">
            <div class="row">
                <div class="col-md-2 mt-4">
                    <mat-label>{{ 'CATEGORY.LABEL' | translate }} *</mat-label>
                </div>
                <div class="col-md-10">
                    <mat-form-field class="example-full-width">
                        <input matInput formControlName="label"
                               [errorStateMatcher]="matcher" type="text">
                        <mat-error *ngIf="getControl?.label?.errors?.required">
                            {{ 'CATEGORY.LABEL_REQUIRED_ERROR_LABEL' | translate }}
                            <strong>{{ 'COMMON.REQUIRED_MALE' | translate }}</strong>
                        </mat-error>
                    </mat-form-field>
                    <mat-error style="font-size: 75%;" *ngIf="duplicatedLabelMessageError">
                        {{ 'CATEGORY.LABEL_DUPLICATED_ERROR_LABEL' | translate }}
                    </mat-error>
                </div>
            </div>
            <div class="row">
                <div class="col-md-2 mt-5">
                    <mat-label>{{ 'CATEGORY.BACKGROUND_IMAGE' | translate }} *</mat-label>
                </div>
                <div class="col-md-10" *ngIf="!displayImage">
                    <p-fileUpload #fileUpload (onSelect)="onUpload($event)" (onClear)="clearFile()"
                                  [showUploadButton]="false"
                                  accept="image/*">
                    </p-fileUpload>
                    <mat-error style="font-size: 75%;" *ngIf="noFileUploaded">
                        {{ 'PARTNER.IMAGE_REQUIRED_LABEL' | translate }}
                        <strong>{{ 'COMMON.REQUIRED_FEMALE' | translate }}</strong>
                    </mat-error>
                </div>
                <div class="col-md-10" *ngIf="displayImage">
                            <span class="logo-tooltip" (click)="changeImageValue()">
                                <img [src]="getControl?.backgroundImage?.value" class="middle-logo"/>
                            </span>
                </div>
            </div>
            <div class="row mt-4" *ngIf="!displayEmoji">
                <div class="col-md-2 mt-4">
                    <mat-label>{{ 'CATEGORY.EMOJI' | translate }} *</mat-label>
                </div>
                <div class="col-md-10">
                    <div class="col-md-10">
                        <p class="emoji"
                           [innerHTML]="sanitizer.bypassSecurityTrustHtml(getControl?.emoji?.value)"></p>
                    </div>
                    <div *ngIf="isEmojiPickerVisible">
                        <emoji-mart class="emoji-mart" (emojiSelect)="addEmoji($event)"
                                    [i18n]="emojiPickerLabels"></emoji-mart>
                    </div>
                </div>
            </div>
            <div class="row mt-4" *ngIf="displayEmoji">
                <div class="col-md-2">
                    <mat-label>{{ 'CATEGORY.EMOJI' | translate }} *</mat-label>
                </div>
                <div class="col-md-10">
                    <p class="emoji" (click)="openEmojiPicker()"
                       [innerHTML]="sanitizer.bypassSecurityTrustHtml(getControl?.emoji?.value)"></p>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-md-2">
                    <mat-label>{{ 'CATEGORY.FAMILY' | translate }}</mat-label>
                </div>
                <div class="col-md-10">
                    <p-checkbox formControlName="family"
                                [binary]="true"></p-checkbox>
                </div>
            </div>
        </form>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{ 'BUTTONS.SAVE' | translate }}" icon="pi pi-check" class="p-button-text"
                (click)="addOrUpdateCategory()"></button>
    </ng-template>
</p-dialog>
<p-toast></p-toast>
<p-confirmDialog #cd header="Confirmation"
                 icon="pi pi-exclamation-triangle"
                 acceptLabel="{{ 'BUTTONS.YES' | translate }}"
                 rejectLabel="{{ 'BUTTONS.NO' | translate }}"
>
    <ng-template pTemplate="footer">
        <button type="button" pButton icon="pi pi-check" label="Yes" (click)="cd.accept()"></button>
        <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
    </ng-template>
</p-confirmDialog>
